import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { COMPANY_TYPES, COMPANY_TYPE_LABELS } from '../../../constants/company-types';
import CONTRACT_INPUT_LABEL_PROPS from './contractInputLabelProps';

const CompanyTypeInput = ({ input, obj, handleInfoFunc }) => (
  <TextField
    select
    sx={input.sx}
    id={input.id}
    label={input.label}
    disabled={input.disabled}
    value={obj[input.id] || ''}
    onChange={(e) => handleInfoFunc(input.id, e.target.value, obj.id)}
    SelectProps={{ className: input.selectClassName }}
    InputLabelProps={CONTRACT_INPUT_LABEL_PROPS}
  >
    {Object.values(COMPANY_TYPES).map((companyType) => (
      <MenuItem key={companyType} value={companyType}>
        {COMPANY_TYPE_LABELS[companyType]}
      </MenuItem>
    ))}
  </TextField>
);

CompanyTypeInput.propTypes = {
  input: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    selectClassName: PropTypes.string,
    sx: PropTypes.shape({
      width: PropTypes.string,
    }),
  }).isRequired,
  obj: PropTypes.shape({
    id: PropTypes.number,
    rut: PropTypes.string,
    mainDisabled: PropTypes.bool,
  }).isRequired,
  handleInfoFunc: PropTypes.func.isRequired,
};

export default CompanyTypeInput;
